import { ALLOCATION_UNIT } from './fields'

export const transformRightAllocationUnit = (right = {}, allocationUnits = []) => {
  const allocationUnit = allocationUnits.find(unit => unit.name === right[ALLOCATION_UNIT])
  return allocationUnit && allocationUnit.id
}
